



















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { Branch } from '@/api/model/branch'
import { PipelineAPI } from '@/api/backend-client'
import { escapeHtml } from '@/helpers/html'

@Component
export default class EditPipelineTurnoverModal extends Vue {
    @Prop({ required: true }) readonly pipeline!: Pipeline
    @Prop({ type: Boolean, default: false }) readonly value!: boolean

    branch: Branch = null
    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async save() {
        try {
            this.loading = true

            this.availableLinkedBranches.forEach(LinkedBranch => {
                this.pipeline.branches.push(LinkedBranch.branch)
            })

            await PipelineAPI.update(this.pipeline.id, this.pipeline)

            this.visible = false
            this.$emit('close', this.pipeline)
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.loading = false
        }
    }

    showModal(): void {
        this.visible = true
    }

    hideModal(): void {
        this.visible = false
        this.$emit('close', this.pipeline)
    }

    get availableLinkedBranches() {
        if (!this.pipeline) {
            return []
        }

        return this.pipeline.linkedBranches
    }
}
